<template>
  <div class="new-rich-text ly-card">
    <el-tabs type="border-card" v-model="key" @tab-click="change">
      <el-tab-pane label="中心简介" name="ABOUT_US"></el-tab-pane>
      <el-tab-pane label="报名提醒" name="SIGN_UP_NOTICE"></el-tab-pane>
      <el-tab-pane label="报名须知" name="NOTE_FOR_APPLICATION"></el-tab-pane>
      <el-tab-pane label="报名协议" name="SIGN_UP_PROTOCOL"></el-tab-pane>
      <el-tab-pane label="支付说明" name="PAYMENT_INSTRUCTION"></el-tab-pane>
      <el-tab-pane label="注册协议" name="REGISTRATION_AGREEMENT"></el-tab-pane>
      <el-tab-pane label="退款协议" name="REFUND_AGREEMENT"></el-tab-pane>
      <el-tab-pane label="隐私协议" name="PRIVACY_AGREEMENT"></el-tab-pane>
      <el-tab-pane label="知情书" name="Payment_Prompt_Description"></el-tab-pane>
    </el-tabs>
    <tinymce ref="tinymce" v-model="values[key]" :height="500" />
    <el-button type="primary" class="m-t-20" @click.native="submit">保存</el-button>
  </div>
</template>
<script>
import { Tabs, TabPane } from 'element-ui';
import Tinymce from '@/components/Tinymce';
import { frontInf } from '@/api';

export default {
  name: 'richText',
  components: {
    ElTabs: Tabs,
    ElTabPane: TabPane,
    Tinymce
  },
  data() {
    return {
      KEYS: Object.freeze({
        ABOUT_US: 1,
        SIGN_UP_NOTICE: 2,
        PAYMENT_INSTRUCTION: 3,
        NOTE_FOR_APPLICATION: 4,
        SIGN_UP_PROTOCOL: 5,
        REGISTRATION_AGREEMENT: 6,
        REFUND_AGREEMENT: 7,
        PRIVACY_AGREEMENT: 8,
        Payment_Prompt_Description: 9
      }),
      key: 'ABOUT_US',
      values: {
        ABOUT_US: '',
        SIGN_UP_NOTICE: '',
        PAYMENT_INSTRUCTION: '',
        NOTE_FOR_APPLICATION: '',
        SIGN_UP_PROTOCOL: '',
        REGISTRATION_AGREEMENT: '',
        REFUND_AGREEMENT: '',
        PRIVACY_AGREEMENT: '',
        Payment_Prompt_Description: ''
      },
      content: ''
    };
  },
  mounted() {
    this.change();
  },
  methods: {
    submit() {
      if (this.values[this.key] !== '') {
        frontInf.setFrontContent({
          params: {
            module: this.KEYS[this.key],
            content: this.values[this.key]
          }
        }).then(res => {
          if (res) {
            this.$message.success(res.msg || '保存成功！');
          }
        });
      }
    },
    change() {
      if (this.values[this.key] === '') {
        frontInf.getFrontContent({
          params: {
            module: this.KEYS[this.key]
          }
        }).then(res => {
          if (res && res.data) {
            const { content } = res.data;
            if (typeof content === 'string') {
              this.values[this.key] = content;
              this.$refs.tinymce.setContent(content);
            } else {
              this.values[this.key] = '';
              this.$refs.tinymce.setContent('');
            }
          }
        });
      } else {
        this.$refs.tinymce.setContent(this.values[this.key]);
      }
    }
  }
};
</script>
